"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
/* eslint-disable */
var _default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "m18.848 3.551 1.602 1.602a1.886 1.886 0 0 1 0 2.664l-1.069 1.07a.377.377 0 0 1-.533 0l-3.734-3.734a.377.377 0 0 1 0-.533l1.07-1.069a1.886 1.886 0 0 1 2.664 0ZM14.314 5.955a.377.377 0 0 0-.534-.001l-8.24 8.242a.377.377 0 0 0 0 .533l3.733 3.733a.377.377 0 0 0 .533 0l8.236-8.236a.377.377 0 0 0 0-.532l-3.728-3.74ZM4.78 15.622a.377.377 0 0 0-.634.179L3.01 20.536a.377.377 0 0 0 .455.454l4.732-1.131a.377.377 0 0 0 .179-.634L4.78 15.622Z"
})), "0 0 24 24", "Edit");
exports.default = _default;